import * as React from 'react';

import { translate } from '~l10n/client';

import GenerateCodeIcon from 'GenerateCodeIcon';
import InfoIcon from 'InfoIcon';
import OkIconCircle from 'OkIconCircle';
import platform from 'Platform';

export default class ShareRoomView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlighted: false,
      newLink: false,
      selected: false,
    };
  }

  componentDidMount() {
    this.shareInput.focus();

    if (this.props.showInfo) {
      this.setState({
        highlighted: true,
      });

      setTimeout(() => {
        this.setState({
          highlighted: false,
        });
      }, 800);
    }
  }

  linkCopied() {
    this.urlFocus();

    document.execCommand('copy');

    this.setState({
      selected: true,
      highlighted: true,
    });

    this.shareInput.blur();
  }

  urlFocus() {
    this.shareInput.focus();
    this.shareInput.setSelectionRange(0, this.shareInput.value.length);
  }

  render() {
    let copyButtonHTML = translate('Copy');

    if (this.state.selected) {
      copyButtonHTML = (
        <span>
          <OkIconCircle />
          {translate('Copied')}
        </span>
      );
    }

    return (
      <div
        className={
          platform.isMobile() && !platform.isTablet
            ? 'share-room-container mobile-form form'
            : 'share-room-container form'
        }
      >
        <p
          className={
            this.state.highlighted ? 'share-room-copy' : 'share-room-copy test'
          }
        >
          {translate(
            'Share this URL with students to give them direct access to this room.'
          )}
        </p>
        <p className="current-room">
          {translate('Copy room URL for “{0}”').format(
            this.props.roomName.toUpperCase()
          )}
        </p>
        <div
          className={
            this.state.highlighted
              ? 'share-room-form highlighted'
              : 'share-room-form'
          }
        >
          <div
            ref="urlCode"
            className={this.state.selected ? 'share-url copied' : 'share-url'}
          >
            <input
              className={this.state.selected ? 'url copied' : 'url'}
              value={this.props.url}
              readOnly={true}
              ref={(input) => (this.shareInput = input)}
              onFocus={() => this.urlFocus()}
            />
            <button
              className={
                this.state.selected
                  ? 'button-secondary button-large copied'
                  : 'button-secondary button-large'
              }
              onClick={() => this.linkCopied()}
            >
              {copyButtonHTML}
            </button>
          </div>
        </div>
        <div className="share-room-bottom clearfix">
          <a
            className="generate-new-button"
            onClick={() => this.props.regenerateLink(this.props.roomName)}
          >
            <GenerateCodeIcon />
            <span>{translate('Generate New')}</span>
          </a>
          <span
            className="share-info-text align-left"
            style={{
              display: this.props.showInfo ? 'block' : 'none',
            }}
          >
            <InfoIcon color="#309bff" />
            <span>{translate('Previous URL is no longer active.')}</span>
          </span>
        </div>
      </div>
    );
  }
}
